import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rss",
  "use": "rss-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"rss\"><path fill-rule=\"evenodd\" d=\"M4.5 17c.8 0 1.5-.7 1.5-1.5S5.3 14 4.5 14 3 14.7 3 15.5 3.7 17 4.5 17Zm14 1C18.5 9 11 1.5 2 1.5v1c8.6 0 15.5 7 15.5 15.5h1Zm-6 0C12.5 12.2 7.8 7.5 2 7.5v1c5.2 0 9.5 4.3 9.5 9.5h1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol